// @flow

import React from 'react';
import branch from 'recompose/branch';
import mapProps from 'recompose/mapProps';
import renderComponent from 'recompose/renderComponent';
import { Redirect } from 'react-router-dom';

type Predicate = (props: Object) => boolean;

const withoutToken = mapProps(({ token, ...rest }) => rest);

const withAuthentication = (isUnauthenticated: Predicate) =>
  branch(
    isUnauthenticated,
    renderComponent((props) => <Redirect to={`/login?returnTo=${props.location.pathname}`} />),
    withoutToken,
  );

export default withAuthentication(({ token }) => Boolean(token) === false);
